module.exports = "    <app-navbar></app-navbar>\n    <router-outlet (activate)=\"onActivate($event)\" ></router-outlet>\n    <app-footer></app-footer>\n"